import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import type { Lang } from '../data/i18n';
interface LanguageToggleProps {
  /** 'compact' para la barra de navegación, 'full' para el menú móvil y el pie. */
  size?: 'compact' | 'full';
  /** El globo ocupa espacio: se puede ocultar en pantallas pequeñas. */
  showIcon?: boolean;
  className?: string;
}
const options: Array<{
  value: Lang;
  label: string;
}> = [{
  value: 'en',
  label: 'EN'
}, {
  value: 'es',
  label: 'ES'
}];

/** Selector de idioma visible: dos segmentos, el activo en Guards Red. */
export function LanguageToggle({
  size = 'compact',
  showIcon = true,
  className = ''
}: LanguageToggleProps) {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  const pad = size === 'full' ? 'px-5 py-2.5 text-[13px]' : 'px-3 py-1.5 text-[12px]';
  return <div role="group" aria-label={t.languageLabel} className={`flex items-center gap-1 border border-line bg-canvas p-1 ${className}`} data-id="element-195" data-mp="1mpbquvk8n8ts">
      {showIcon && <GlobeIcon className={`${size === 'full' ? 'ml-2 h-4 w-4' : 'ml-1.5 h-[14px] w-[14px]'} text-mute`} aria-hidden="true" data-id="element-196" data-mp="16xagczpp1591" />}
      {options.map(option => {
      const active = option.value === lang;
      return <button key={option.value} type="button" onClick={() => setLang(option.value)} aria-pressed={active} aria-label={option.value === 'en' ? 'English' : 'Español'} lang={option.value} className={`${pad} font-semibold tracking-[0.14em] transition-colors duration-500 ease-[var(--ease-lux)] ${active ? 'bg-guards text-white' : 'bg-transparent text-mute hover:text-white'}`} data-id="element-197" data-mp="1llez23oqxgrt">
            {option.label}
          </button>;
    })}
    </div>;
}